import { render, staticRenderFns } from "./PNDPackagesTile.vue?vue&type=template&id=a9ac098c"
import script from "./PNDPackagesTile.vue?vue&type=script&lang=ts"
export * from "./PNDPackagesTile.vue?vue&type=script&lang=ts"
import style0 from "./PNDPackagesTile.vue?vue&type=style&index=0&id=a9ac098c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports